import React from 'react';
import { Overlay } from '~/ui/overlay/Overlay';
import { BackButton } from './BackButton';
import { Background } from './Background';
import { Cards } from './cards/Cards';
import { Intro } from './Intro';
import { Outro } from './Outro';
import { Username } from './Username';
import { LanguageSelection } from './LanguageSelection';
import { OnboardingProvider } from './Store';

export const Onboarding = () => {
  return (
    <OnboardingProvider>
      <Background />
      <Overlay open>
        <BackButton />
        <Intro />
        <LanguageSelection isOnboarding={true} />
        <Username />
        <Cards />
        <Outro />
      </Overlay>
    </OnboardingProvider>
  );
};
